import $ from 'jquery';

$(document).on('hidden.bs.collapse','.js-menu-contents', function () {
    $('.js-default-menu-teaser-blocks').collapse('show');
  })